const common = {
  Test: '測試',
};

export default common;
